export enum FatnessCategoryFilter {
	All = 'all',
	Normal = 'ok',
	Deviation = 'attention',
	Obesity = 'obese',
	Emaciation = 'emaciated',
	WithoutNorm = 'without_norm',
}

export const FATNESS_CATEGORY_TABS = [
	{ key: FatnessCategoryFilter.All, title: 'Все' },
	{ key: FatnessCategoryFilter.Normal, title: 'В норме' },
	{ key: FatnessCategoryFilter.Deviation, title: 'С отклонением' },
	{ key: FatnessCategoryFilter.Obesity, title: 'С ожирением' },
	{ key: FatnessCategoryFilter.Emaciation, title: 'С истощением' },
	{ key: FatnessCategoryFilter.WithoutNorm, title: 'Без нормы упитанности' },
]

const SCORE_LABELS = new Map<number, string>([
	[1, '1 балл'],
	[1.25, '1,25 балла'],
	[1.5, '1,5 балла'],
	[1.75, '1,75 балла'],
	[2, '2 балла'],
	[2.25, '2,25 балла'],
	[2.5, '2,5 балла'],
	[2.75, '2,75 балла'],
	[3, '3 балла'],
	[3.25, '3,25 балла'],
	[3.5, '3,5 балла'],
	[3.75, '3,75 балла'],
	[4, '4 балла'],
	[4.25, '4,25 балла'],
	[4.5, '4,5 балла'],
	[4.75, '4,75 балла'],
	[5, '5 баллов'],
])

const ALL_SCORES = Array.from(SCORE_LABELS.keys())

const SCORES_BY_CATEGORY: Record<FatnessCategoryFilter, number[]> = {
	[FatnessCategoryFilter.All]: ALL_SCORES,
	[FatnessCategoryFilter.Normal]: [2.5, 2.75, 3, 3.25, 3.5, 3.75],
	[FatnessCategoryFilter.Deviation]: [
		1.75, 2, 2.25, 2.5, 2.75, 3, 3.5, 3.75, 4, 4.25,
	],
	[FatnessCategoryFilter.Obesity]: [4.5, 4.75, 5],
	[FatnessCategoryFilter.Emaciation]: [1, 1.25, 1.5],
	[FatnessCategoryFilter.WithoutNorm]: ALL_SCORES,
}

export const getFatnessScoreOptions = (category: FatnessCategoryFilter) =>
	SCORES_BY_CATEGORY[category].map(type => ({
		type,
		value: SCORE_LABELS.get(type) ?? String(type),
	}))

const EMPTY_CATEGORY_MESSAGES: Record<FatnessCategoryFilter, string> = {
	[FatnessCategoryFilter.All]: 'Коров не обнаружено',
	[FatnessCategoryFilter.Normal]: 'Коров с упитанностью в норме не обнаружено',
	[FatnessCategoryFilter.Deviation]:
		'Коров с отклонением по упитанности не обнаружено',
	[FatnessCategoryFilter.Obesity]: 'Коров с ожирением не обнаружено',
	[FatnessCategoryFilter.Emaciation]: 'Коров с истощением не обнаружено',
	[FatnessCategoryFilter.WithoutNorm]:
		'Коров без нормы упитанности не обнаружено',
}

export const getFatnessEmptyMessage = (
	category: FatnessCategoryFilter,
	hasAdditionalFilters: boolean,
) =>
	hasAdditionalFilters
		? 'Данных, соответствующих выбранным условиям, не обнаружено'
		: EMPTY_CATEGORY_MESSAGES[category]
